import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import updateSelectedWobs from './update-selected-wobs'
import colorPickerMenu from 'scoreboard/dashboards/widgets/color-picker-menu'

var NO_OUTLINE = 'none'

var OutlineWidthOption = Backbone.View.extend({
	className: 'config-checkmark',

	events: {
		'click': 'select'
	},

	initialize: function () {
		this.listenTo(this.model.wob, 'change:outlineWidth', this.render.bind(this))
	},

	render: function () {
		this.$el.html(icon('outline', 'outline-icon') + i18n.get('dashboards.outline.' + (this.width === NO_OUTLINE ? 'noOutline' : this.width)))
			.toggleClass('is-selected', this.selected())
			.addClass('outline-width outline-width-' + this.width)
			.append(icon('approved', 'check-icon'))

		return this
	},

	selected: function () {
		var current = this.model.wob.get('outlineWidth')
		return this.width === NO_OUTLINE ? !current : current === this.width
	},

	select: function () {
		this.model.trigger('record')

		updateSelectedWobs(this.canvas, wob => {
			wob.widget.outlineWidth(this.width === NO_OUTLINE ? null : this.width)
		})
	}
})

function createOutlineWidthMenu (canvas, opt = {}) {
	let showNoOutline = opt?.showNoOutline ?? true
	let sizes = _([1, 2, 3, 5, 10])
		.map(function (width) { return width + 'px' })
		.value()

	if (showNoOutline) {
		sizes.unshift(NO_OUTLINE)
	}

	let options = sizes.map(width => {
		return {
			label: width,
			contentView: OutlineWidthOption.extend({ width: width, canvas: canvas })
		}
	})

	return {
		type: 'submenu',
		label: opt.label ?? 'dashboards.outline',
		target: options
	}
}

function createOutlineColorMenu (bootslideMenu, widgetModel, opt = {}) {
	return colorPickerMenu(bootslideMenu, widgetModel, _.extend({}, {
		id: 'outlineColor',
		label: opt.label ?? 'dashboards.outlineColor',
		source: {
			model: widgetModel.wob,
			property: 'outlineColor'
		},
		propertySetter: (wobModel, color) => wobModel.widget.outlineColor(color)
	}, opt))
}

export const width = createOutlineWidthMenu
export const color = createOutlineColorMenu
